import { render } from "./FotoTextoDerecha.vue?vue&type=template&id=7507c63c"
import script from "./FotoTextoDerecha.vue?vue&type=script&lang=js"
export * from "./FotoTextoDerecha.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__